import {
    IAccountStatistic,
} from 'entities/account-statistics/types/account-statistic';

import {
    useEffect,
    useState,
} from 'react';

import {
    useInterval,
} from 'tools/hooks';

import {
    IGetAccountStatisticDto,
} from 'entities/account-statistics/requests/get-account-statistic.dto';
import {
    IGetAccountStatisticResponse,
} from 'entities/account-statistics/responses/get-account-statistic.response';
import {
    PAYMENT_PAGE_TYPE,
} from 'entities/payment-methods/constants';

import {
    PAYMENT_STATUS_POLLING_MS,
} from '../constants';

interface IParams {
    encodedId: string | null;
    accountStatistic: IAccountStatistic | null;
    locale: string;
    isPolling: boolean;

    getAccountStatistic(encodedId: string, dto: IGetAccountStatisticDto): Promise<IGetAccountStatisticResponse>;
    onSubmit(): Promise<void>;
}

export function usePaymentStatusSync({
    encodedId,
    accountStatistic,
    locale,
    isPolling,
    getAccountStatistic,
    onSubmit,
}: IParams) {
    const [isPending, setIsPending] = useState(true);

    useEffect(() => {
        (async () => {
            if (!encodedId) {
                setIsPending(false);

                return;
            }

            const res = await getAccountStatistic(encodedId, {
                locale,
            });

            if (res.accountStatistic?.paymentMethod.paymentPageType === PAYMENT_PAGE_TYPE.UPI_INTENT_QR) {
                return;
            }

            setIsPending(false);
        })();
    }, []);
    useEffect(() => {
        (async () => {
            if (!isPending) {
                return;
            }
            if (!accountStatistic) {
                return;
            }
            if (accountStatistic.paymentMethod.paymentPageType !== PAYMENT_PAGE_TYPE.UPI_INTENT_QR) {
                return;
            }
            if (accountStatistic.payment) {
                setIsPending(false);

                return;
            }

            await onSubmit();
            setIsPending(false);
        })();
    }, [accountStatistic, isPending]);

    useInterval(async () => {
        if (!encodedId) {
            return;
        }
        if (!isPolling) {
            return;
        }

        await getAccountStatistic(encodedId, {
            locale,
        });
    }, PAYMENT_STATUS_POLLING_MS, [isPolling]);

    return {
        isPending,
    };
}
